import { v1 } from './v1';

export const hotspots = {
  v1,
};
